import React from "react";
import './HoverTech.css';

const techlist = [
  { atltag: "aws", link: "http://aws.com", srcImage: "/assets/images/tech/tech1.jpg" },
  { atltag: "ibm watson", link: "https://www.ibm.com/watson", srcImage: "/assets/images/tech/tech2.png" },
  { atltag: "node js", link: "https://nodejs.org", srcImage: "/assets/images/tech/tech4.png" },
  // { atltag: "mongo DB", link: "https://www.mongodb.com/", srcImage: "/assets/images/tech/tech6.png" },
  { atltag: "github", link: "https://github.com/", srcImage: "/assets/images/tech/tech8.jpg" },
  { atltag: "React", link: "https://reactjs.org/", srcImage: "/assets/images/tech/tech10.png" },
  // { atltag: "MySQL", link: "https://www.mysql.com/", srcImage: "/assets/images/tech/tech5.png" },
  // { atltag: "jQuery", link: "https://jquery.com/", srcImage: "/assets/images/tech/tech9.png" },
  { atltag: "Google", link: "https://cloud.google.com/", srcImage: "/assets/images/tech/tech11.png" }
];

function TechUsed() {
  return (
    <div className="container">
      <div
        className="col-12"
        style={{
          textAlign: "center",
          paddingTop: "75px",
          paddingBottom: "75px",
          backgroundColor: "white"
        }}
      >
        <div>
          <h1>Technology used</h1>
        </div>
      </div>

      <div className="row">
        <div className="col-7" style={{ textAlign: "center", margin: "auto" }}>
          {techlist.map((item, i) => (
            <a key={i} href={item.link} target="_blank" rel="noreferrer">
              <div style={{ display: "inline-block" }}>
                <img
                  className="techUsed"
                  src={item.srcImage}
                  height="150px"
                  alt={item.atltag}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TechUsed;